var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editDealerContainer"}},[_c('dealer',{attrs:{"dealer-id":this.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }